const { BACKEND_PORT } = process.env;
export const { BACKEND_HOST } = process.env;
export const { MOKA_SERVICE_HOST } = process.env;
export const { MOKA_OPEN_API_HOST } = process.env;
export const { MOKA_GOAUTH_SERVICE } = process.env;
export const { GOID_SERVICE } = process.env;
export const PUSHER_APP_KEY = process.env.PUSHER_INVENTORY_KEY;

export const { GOBIZ_OAUTH_URL } = process.env;
export const { GOBIZ_OAUTH_CALLBACK_URL } = process.env;
export const { GOBIZ_OAUTH_CLIENT_ID } = process.env;

export const { UNLEASH_URL } = process.env;
export const { UNLEASH_CLIENT_KEY } = process.env;
export const { UNLEASH_APP_NAME } = process.env;

export const HOST = `${BACKEND_HOST}:${BACKEND_PORT}`;
export const INVENTORY_PUSHER_CHANNEL = (businessId, outletId) =>
  `moka-${outletId}-${businessId}-inventory`;
export const INVENTORY_BUSINESS_PUSHER_CHANNEL = (businessId) =>
  `moka-${businessId}-inventory`;
export const INVENTORY_CLONE_OUTLET_PUSHER_EVENT = 'outlet/clone';
export const MOKA_ACCOUNT_API = `${MOKA_SERVICE_HOST}/account`;
export const MOKA_COUPON_BILLING_API = `${MOKA_SERVICE_HOST}/billing-coupon`;
export const MOKA_INVENTORY_API = `${MOKA_SERVICE_HOST}/inventory`;
export const MOKA_SHADOW_TRAFFIC_INVENTORY_API = `${MOKA_SERVICE_HOST}/shadow-traffic-proxy`;
export const MOKA_TRANSFER_API = `${MOKA_SERVICE_HOST}/transfer`;
export const MOKA_STOCK_TRANSFER_API = `${MOKA_SERVICE_HOST}/stock-transfer`;
export const MOKA_BUNDLE_PACKAGE_API = `${MOKA_SERVICE_HOST}/bundle-package`;
export const API_URL = `${HOST}/api`;
export const LOGIN_URL = `${MOKA_ACCOUNT_API}/v1/login`;
export const REGISTER_URL = `${HOST}/validate_email`;
export const VALIDATE_PHONE = `${HOST}/api/v1/validate_phone_number`;
export const VERIFY_UPDATE_OTP_URL = `${MOKA_SERVICE_HOST}/account/v2/verification/phone/verify`;
export const VERIFY_OTP_URL = `${MOKA_SERVICE_HOST}/account/v2/verification/phone/verify`;
export const GENERATE_OTP = `${MOKA_SERVICE_HOST}/account/v1/verification/phone/send`;
export const FORGOT_PASSWORD_OTP_URL = `${API_URL}/v2/users/forgot_password`;
export const UPLOAD_NPWP_FILE_URL = `${MOKA_SERVICE_HOST}/upload/image?crop=false`;
export const BUSINESS_IDENTITIES_URL = `${MOKA_SERVICE_HOST}/business-service/v3/businesses/identities`;
export const BUSINESS_TYPES = `${HOST}/business_types`;
export const BUSINESS_TYPES_FROM_SERVICE = `${MOKA_SERVICE_HOST}/business-service/v1/business-types`;
export const BUSINESS_INFO_URL = `${HOST}/api/v1/businesses/`;
export const BUSINESS_INFO_UPDATE_SERVICE_URL = `${MOKA_SERVICE_HOST}/business-service/v1/businesses/info`;
export const RESEND_VERIFICATION_EMAIL_URL = `${HOST}/resend_verification_email`;
export const BUSINESS_CATEGORIES = `${HOST}/business_categories?business_type_id=$id`;
export const BUSINESS_TYPES_URL = `${HOST}/business_types`;
export const BUSINESS_TYPES_URL_FROM_SERVICE = `${MOKA_SERVICE_HOST}/business-service/v1/business-types`;
export const BUSINESS_CATEGORIES_URL = `${HOST}/business_categories`;
export const BUSINESS_CATEGORIES_ALL_URL = `${HOST}/api/v1/business_categories_all`;
export const BUSINESS_CATEGORIES_ALL_URL_FROM_SERVICE = `${MOKA_SERVICE_HOST}/business-service/v1/business-categories`;
export const BUSINESS_OPENINGS_CHOICES_URL = `${MOKA_SERVICE_HOST}/business-service/v1/businesses/opening-choices`;
export const BUSINESS_LOCATIONS_URL = `${HOST}/province_all`;
export const BUSINESS_PROVINCE_URL = `${MOKA_SERVICE_HOST}/business-service/v1/province/all`;
export const BUSINESS_ZIPCODE_URL = `${MOKA_SERVICE_HOST}/business-service/v1/kecamatan/`;
export const BUSINESS_KECAMATAN_URL = `${MOKA_SERVICE_HOST}/business-service/v1/city/`;
export const BUSINESS_INVENTORY_SETTINGS = `${MOKA_SERVICE_HOST}/business-service/v1/businesses/setting-inventory`;
export const BANK_LIST_URL = `${MOKA_SERVICE_HOST}/business-service/v1/business/banks`;
export const BUSINESS_CATEGORIES_ALL = `${HOST}/get_all_business_categories`;
export const REGISTER_BUSINESS_URL = `${HOST}/api/v1/create_user`;
export const UPDATE_SELECTED_OUTLET = `${API_URL}/v2/login/outlets`;
export const GET_PROFILE = `${MOKA_ACCOUNT_API}/v1/profile`;
export const GET_PROFILE_V2 = `${MOKA_ACCOUNT_API}/v2/profile`;
export const GET_DASHBOARD = `${API_URL}/v1/dashboard`;
export const REFERRAL_URL = `${HOST}/referral`;
export const SUBSCRIPTION_STATUS = `${API_URL}/v1/feature/get_subscription_status`;
export const BUSINESS_CITY_URL = `${MOKA_SERVICE_HOST}/business-service/v1/province/`;
export const MOKA_ADVANCED_ORDERING_HOST = `${MOKA_SERVICE_HOST}/advance-ordering`;
export const GET_ACTIVE_BUSINESS_APP = (userId: string) => {
  return `${MOKA_OPEN_API_HOST}/v1/users/${userId}/authorized_apps`;
};
export const GENERATE_OTP_V2_URL = `${MOKA_SERVICE_HOST}/account/v2/verification/phone/send`;
export const VERIFY_OTP_V2_URL = `${MOKA_SERVICE_HOST}/account/v1/verification/phone/verify-legacy`;

/**
 * Customer Endpoints
 */
export const CUSTOMER_SERVICE_URL = `${MOKA_SERVICE_HOST}/customer/v1`;

/**
 * Category endpoints
 */
export const LIST_CATEGORY_URL = `${API_URL}/v1/categories`;
export const LIST_CATEGORY_URL_OPTIMIZE = `${MOKA_INVENTORY_API}/v1/categories`;
export const LIST_CATEGORY_WITH_UNCATEGORIZED_URL = `${API_URL}/v1/categories/with_uncategorized`;
export const LIST_CATEGORY_WITH_UNCATEGORIZED_URL_OPTIMIZE = `${MOKA_INVENTORY_API}/v1/categories/with_uncategorized`;

/**
 * Old reporting endpoints
 */

// Migration pending
export const REPORT_TRANSACTION = `${API_URL}/v1/reports/transactions`;
export const REPORT_TRANSACTION_DETAIL = (transactionId: string) => {
  return `${API_URL}/v1/reports/${transactionId}/transaction_detail`;
};
export const INVOICES_URL = `${API_URL}/v1/reports/invoices`;

// Migration pending (API not ready yet)
export const EXPORT_TRANSACTION = `${API_URL}/v1/reports/export_transactions`;
export const EXPORT_TRANSACTION_BY_ITEM = `${API_URL}/v1/reports/export_by_item`;
export const EXPORT_SUMMARY_OPTIMIZE = `${MOKA_SERVICE_HOST}/reporting/v1/reports/export_sales_summary`;
export const EXPORT_SALES_TYPE = `${API_URL}/v1/reports/export_sales_type`;
export const EXPORT_GROSS_PROFIT_OPTIMIZE = `${MOKA_SERVICE_HOST}/reporting/v1/reports/export_gross_profit`;
export const EXPORT_HOURLY_ITEM_SOLD = `${MOKA_SERVICE_HOST}/reporting/v1/reports/export_item_sold`;
export const EXPORT_HOURLY_ITEM_AMOUNT = `${MOKA_SERVICE_HOST}/reporting/v1/reports/export_item_amount`;
export const EXPORT_PAYMENT_METHOD_OPTIMIZE = `${MOKA_SERVICE_HOST}/reporting/v1/reports/export_payment_methods`;
export const EXPORT_ITEM_SALES_OPTIMIZE = `${MOKA_SERVICE_HOST}/reporting/v1/reports/export_item_sales`;
export const EXPORT_CATEGORY_SALES_OPTIMIZE = `${MOKA_SERVICE_HOST}/reporting/v1/reports/export_category_sales`;
export const EXPORT_MODIFIER_SALES = `${API_URL}/v1/reports/export_modifiers`;
export const EXPORT_DISCOUNT = `${MOKA_SERVICE_HOST}/report/v1/discounts/export`;
export const EXPORT_TAXES = `${API_URL}/v1/reports/export_taxes`;
export const EXPORT_GRATUITY = `${API_URL}/v1/reports/export_gratuities`;
export const EXPORT_COLLECTEDBY = `${API_URL}/v1/reports/export_staff_report`;
export const EXPORT_SERVEDBY = `${API_URL}/v1/reports/export_servers`;

//----

/** **
 * Cash drawer - shifts endpoints
 */
export const CASH_DRAWER_SHIFT_SUMMARY = `${API_URL}/v1/cash_drawer/shifts/summary`;
export const CASH_DRAWER_LIST_SHIFT = `${API_URL}/v1/cash_drawer/shifts/backoffice`;
export const CASH_DRAWER_LIST_SHIFT_V2 = `${MOKA_SERVICE_HOST}/shift/v2/cash_drawer/shifts`;
export const CASH_DRAWER_LIST_SHIFT_V3 = `${MOKA_SERVICE_HOST}/shift/v3/cash_drawer/shifts`;
export const CASH_DRAWER_EXPORT_SHIFT = `${API_URL}/v1/cash_drawer/shifts/export`;

/**
 * @return {string}
 */
export const CASH_DRAWER_SHIFT_DETAILS = (shiftId: string) => {
  return `${API_URL}/v1/cash_drawer/shifts/${shiftId}`;
};
export const UPDATE_FILTERED_DATE = `${API_URL}/v1/update_filtered_date`;
export const GET_FILTERED_DATE = `${API_URL}/v1/get_filtered_date`;
export const GET_RESET_PASSWORD_URL = `${API_URL}/v1/users/reset_password`;
export const RESET_PASSWORD_URL = `${API_URL}/v1/users/update_password`;
export const LOAD_PREPARE_ENCRYPTION_URL = `${API_URL}/v1/users/prepare_encryption`;

/**
 * Invoices endpoints
 */
export const RECEIPT_INVOICES_URL = (id: string) => {
  return `${API_URL}/v1/invoices/${id}.json`;
};

export const RECORD_PAYMENT_URL = `${API_URL}/v1/invoices/payment_records`;
export const RESEND_EMAIL_URL = (invoiceId) => {
  return `${API_URL}/v1/invoices/${invoiceId}/resend_email`;
};

/** *
 * Email receipt endpoint
 */
export const EMAIL_RECEIPT = `${API_URL}/v1/email_receipt`;

export const REDIRECT_GOBIZ_URL = (randomString: string) => {
  return `${GOBIZ_OAUTH_URL}?client_id=${GOBIZ_OAUTH_CLIENT_ID}&response_type=code&scope=openid%20offline&redirect_uri=${GOBIZ_OAUTH_CALLBACK_URL}&state=${randomString}&user_type=merchant&prompt=login`;
};

/** **********************************************
 * Refund endpoint
 *********************************************** */
export const REFUNDS_V4 = `${HOST}/order/v4/refund-orders`;
export const REFUNDS = `${API_URL}/v2/refunds`;
export const OLD_REFUNDS = `${API_URL}/v1/refunds`;

/** **********************************************************************************************
 * End Refund Endpoint
 *********************************************************************************************** */

/** **********************************************************************************************
 * Outlets endpoint
 *********************************************************************************************** */
export const OUTLETS_URL = `${API_URL}/v1/outlets`;

/** **********************************************************************************************
 * End outlets endpoint
 *********************************************************************************************** */
export const PRINT_RECEIPT_INVOICE_PDF = (invoiceId: string) => {
  return `${API_URL}/v1/invoices/${invoiceId}.pdf`;
};
export const SETTING_ACCOUNT = `${API_URL}/v1/users/settings`;
export const EXPORT_INVOICES = `${API_URL}/v1/invoices/export`;
export const SETTING_PUBLIC_PROFILE = (businessId) => {
  return `${API_URL}/v1/businesses/${businessId}`;
};
export const GET_NEW_IMAGE_URL = `${API_URL}/v1/s3/new`;
export const GET_LOADING_IMAGE = `${HOST}/assets/item-image-loading.gif`;
export const UPLOAD_IMAGE = `https://mokapos-development.s3.amazonaws.com/`;
export const CHECKOUT_SETTING = `${API_URL}/v1/checkout_setting`;

/** **********************************************************************************************
 * Customers feedback endpoint
 *********************************************************************************************** */
export const FEEDBACK_MESSAGES = (feedbackId: string) => {
  return `${API_URL}/v1/customer_feedbacks/${feedbackId}/feedback_messages`;
};
/** **********************************************************************************************
 * End customers feedback endpoint
 *********************************************************************************************** */

/** **********************************************************************************************
 * Customers Service endpoint
 *********************************************************************************************** */
export const CUSTOMER_SERVICE_FEEDBACKS = () => {
  return `${CUSTOMER_SERVICE_URL}/feedbacks`;
};
export const CUSTOMER_SERVICE_FEEDBACK_MESSAGES = (feedbackId: string) => {
  return `${CUSTOMER_SERVICE_URL}/feedbacks/${feedbackId}`;
};
export const CUSTOMER_SERVICE_FEEDBACK_CUSTOMER = (customerId: string) => {
  return `${CUSTOMER_SERVICE_URL}/customers/${customerId}/feedbacks`;
};
export const CUSTOMER_SERVICE_REPLY_FEEDBACK_BY_CUSTOMER = (
  customerId: string,
  feedbackId: string
) => {
  return `${CUSTOMER_SERVICE_URL}/customers/${customerId}/feedbacks/${feedbackId}/replies`;
};
export const CUSTOMERS_SERVICE_SUBMIT_FEEDBACK = (customerId: string) => {
  return `${CUSTOMER_SERVICE_URL}/customers/${customerId}/feedbacks`;
};
export const CUSTOMER_SERVICE_SUBMIT_REPLY_BY_BUSINESS = (
  feedbackId: string
) => {
  return `${CUSTOMER_SERVICE_URL}/feedbacks/${feedbackId}/replies`;
};

export const CUSTOMER_SERVICE_IMPORT = () => {
  return `${CUSTOMER_SERVICE_URL}/import`;
};

export const CUSTOMER_SERVICE_INITIATE_IMPORT_TEMPLATE = () => {
  return `${CUSTOMER_SERVICE_URL}/import/template/job`;
};
export const CUSTOMER_SERVICE_RETRIEVE_IMPORT_TEMPLATE = (fileId: string) => {
  return `${CUSTOMER_SERVICE_URL}/import/${fileId}/template`;
};

export const CUSTOMER_SERVICE_INITIATE_EXPORT_TEMPLATE = () => {
  return `${CUSTOMER_SERVICE_URL}/export/template/job`;
};
export const CUSTOMER_SERVICE_RETRIEVE_EXPORT_TEMPLATE = (fileId: string) => {
  return `${CUSTOMER_SERVICE_URL}/export/${fileId}/template`;
};
/** **********************************************************************************************
 * End Customers Service endpoint
 *********************************************************************************************** */
